import React, { useEffect, useState } from 'react';
import '../CSS/style/style.css';
import RoomCarousel from "./RoomCarousel";

const ROOMS = [
    {
        id: 1,
        name: '자귀나무방', shortName: '자귀방', label: '자귀',
        standard: 8, max: 12,
        layout: '거실 + 방3 + 다락방 + 화장실2 + 싱글침대6 + 퀸침대1',
        type: '단체형 · 가족형',
        price: ['300,000', '420,000', '300,000', '420,000', '420,000', '550,000', '550,000'],
        images: [
            {seq:1,title:'A',img:'A_01.jpeg'},{seq:2,title:'A',img:'A_02.jpeg'},
            {seq:3,title:'A',img:'A_03.jpeg'},{seq:4,title:'A',img:'A_04.jpeg'},
            {seq:5,title:'A',img:'A_05.jpeg'},{seq:6,title:'A',img:'A_06.jpeg'},
            {seq:7,title:'A',img:'A_07.jpeg'},
        ],
    },
    {
        id: 2,
        name: '느릅나무방', shortName: '느릅방', label: '느릅',
        standard: 6, max: 8,
        layout: '거실 + 방 + 다락방 + 화장실 + 싱글침대2 + 퀸침대1 + 2층침대(1층 퀸, 2층 싱글)',
        type: '단체형 · 가족형',
        price: ['180,000', '240,000', '180,000', '300,000', '300,000', '380,000', '380,000'],
        images: [
            {seq:1,title:'B',img:'NUERUEP1.jpeg'},
            {seq:2,title:'B',img:'NUERUEP2.png'},
            {seq:3,title:'B',img:'NUERUEP3.jpg'},
            {seq:4,title:'B',img:'NUERUEP4.jpg'},
            {seq:5,title:'B',img:'NUERUEP5.jpg'},
            {seq:6,title:'B',img:'NUERUEP6.jpg'},
            {seq:6,title:'B',img:'NUERUEP7.jpg'},
        ],
    },
    {
        id: 3,
        name: '소나무방', shortName: '소나무방', label: '소나무',
        standard: 4, max: 6,
        layout: '거실 + 다락방 + 화장실 + 싱글침대4 or 퀸침대2',
        type: '커플형 · 가족형',
        price: ['130,000', '170,000', '130,000', '220,000', '220,000', '300,000', '300,000'],
        images: [
            {seq:1,title:'C',img:'sonamu2.jpeg'},
            {seq:2,title:'C',img:'SONAMU1.png'},
            {seq:3,title:'C',img:'sonamu4.jpeg'},
            {seq:4,title:'C',img:'sonamy3.jpeg'},
        ],
    },
    {
        id: 4,
        name: '이팝나무방', shortName: '이팝방', label: '이팝',
        standard: 4, max: 6,
        layout: '거실 + 다락방 + 화장실 + 싱글침대4 or 퀸침대2',
        type: '커플형 · 가족형',
        price: ['130,000', '170,000', '130,000', '220,000', '220,000', '300,000', '300,000'],
        images: [
            {seq:1,title:'D',img:'EPOP1.jpg'},
            {seq:2,title:'D',img:'EPOP2.jpg'},
            {seq:3,title:'D',img:'EPOP3.jpg'},
            {seq:4,title:'D',img:'EPOP4.jpg'},
            {seq:4,title:'D',img:'EPOP5.jpg'},
        ],
    },
    {
        id: 5,
        name: '보리수방', shortName: '보리수방', label: '보리수',
        standard: 2, max: 4,
        layout: '거실 + 다락방 + 화장실 + 싱글침대4 or 퀸침대2',
        type: '커플형 · 가족형',
        price: ['80,000', '120,000', '80,000', '180,000', '180,000', '250,000', '250,000'],
        images: [
            {seq:1,title:'E',img:'E_01.jpeg'},
            {seq:2,title:'E',img:'E_02.jpeg'},
            {seq:3,title:'E',img:'E_03.jpeg'},
        ],
    },
    {
        id: 6,
        name: '단풍방', shortName: '단풍방', label: '단풍',
        standard: 2, max: 4,
        layout: '거실 + 다락방 + 화장실 + 싱글침대4 or 퀸침대2',
        type: '커플형 · 가족형',
        price: ['80,000', '120,000', '80,000', '180,000', '250,000', '250,000', '250,000'],
        images: [
            {seq:1,title:'F',img:'DANPOUNG3.jpg'},
            {seq:2,title:'F',img:'DANPUNG1.png'},
            {seq:3,title:'F',img:'DANPUNG2.jpg'},
            {seq:3,title:'F',img:'DANPUNG4.jpg'},
            {seq:3,title:'F',img:'DANPUNG5.jpg'},
        ],
    },
];

const FEATURES = ['독채펜션', '펜션 내 계곡', '개별 바베큐장'];

const FACILITIES = [
    { icon: '📺', name: 'TV' },
    { icon: '❄️', name: '에어컨' },
    { icon: '🌀', name: '선풍기' },
    { icon: '🧊', name: '냉장고' },
    { icon: '📡', name: '전자레인지' },
    { icon: '💨', name: '헤어드라이기' },
    { icon: '📶', name: 'Wi-Fi' },
    { icon: '☕', name: '커피포트' },
    { icon: '🍚', name: '압력밥솥' },
    { icon: '🍽️', name: '식기류 일체' },
    { icon: '🚿', name: '샴푸·바디워시' },
    { icon: '🧻', name: '수건·휴지' },
];

const priceHeaders = [
    { label: '비수기', sub: '주중' },
    { label: '비수기', sub: '주말' },
    { label: '준성수기', sub: '주중' },
    { label: '준성수기', sub: '주말' },
    { label: '성수기', sub: '주중' },
    { label: '극성수기', sub: '7/25~8/8·7,8월 주말' },
];

const Rooms = () => {
    const [activeTab, setActiveTab] = useState(1);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const check = () => setIsMobile(window.innerWidth < 768);
        check();
        window.addEventListener('resize', check);
        return () => window.removeEventListener('resize', check);
    }, []);

    const room = ROOMS.find(r => r.id === activeTab);

    return (
        <div className="main-wrapper">
            <section className="foot-banner"></section>

            <div className="main-container">
                <div className="tab-buttons">
                    {ROOMS.map(r => (
                        <button
                            key={r.id}
                            onClick={() => setActiveTab(r.id)}
                            className={activeTab === r.id ? 'tab-button active' : 'tab-button'}
                        >
                            {isMobile ? r.shortName : r.name}
                        </button>
                    ))}
                </div>

                {room && (
                    <>
                        <div className="section-header">
                            <span className="section-label">ROOM</span>
                            <h2 className="section-title">{room.name}</h2>
                        </div>

                        <RoomCarousel key={room.id} images={room.images} idPrefix={room.label} />

                        <div className="room-info-grid">
                            <div className="room-info-card">
                                <p className="room-info-label">구성</p>
                                <p className="room-info-value">{room.layout}</p>
                            </div>
                            <div className="room-info-card">
                                <p className="room-info-label">유형</p>
                                <p className="room-info-value">{room.type}</p>
                            </div>
                            <div className="room-info-card">
                                <p className="room-info-label">기준 / 최대</p>
                                <p className="room-info-value">{room.standard}명 / {room.max}명</p>
                            </div>
                            <div className="room-info-card">
                                <p className="room-info-label">인원 추가</p>
                                <p className="room-info-value">성인·아동 20,000원 / 미취학아동 무료</p>
                            </div>
                        </div>

                        <div className="room-feature-tags">
                            {FEATURES.map(f => (
                                <span key={f} className="room-feature-tag">{f}</span>
                            ))}
                        </div>

                        {/* 데스크톱: 테이블 */}
                        <div className="res-table-wrap room-price-wrap">
                            <table className="refund-table room-price-table">
                                <thead>
                                <tr>
                                    <td>객실</td>
                                    {priceHeaders.map(({ label, sub }) => (
                                        <td key={label + sub}>{label}<br/><span>{sub}</span></td>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{room.label}<br/><span className="res-standard">({room.standard}인 기준)</span></td>
                                    {room.price.filter((_, i) => i !== 5).map((p, i) => (
                                        <td key={i}>{p}원</td>
                                    ))}
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* 모바일: 카드 */}
                        <div className="room-mobile-cards">
                            <div className="room-mobile-card">
                                <div className="room-mobile-header">
                                    <div className="room-mobile-name-wrap">
                                        <span className="room-mobile-name">{room.label}</span>
                                        <span className="room-mobile-standard">{room.standard}인 기준</span>
                                    </div>
                                    <span className="room-mobile-feature">온돌방+침대</span>
                                </div>
                                <div className="room-mobile-price-list">
                                    {[
                                        { season: '비수기',   color: '#4caf50', bg: '#f0f9ee', weekday: room.price[0], weekend: room.price[1] },
                                        { season: '준성수기', color: '#e65100', bg: '#fff3e0', weekday: room.price[2], weekend: room.price[3] },
                                        { season: '성수기',   color: '#c62828', bg: '#fce4ec', weekday: room.price[4] },
                                        { season: '극성수기', color: '#6a1b9a', bg: '#f3e5f5', single: room.price[6] },
                                    ].map(({ season, color, bg, weekday, weekend, single }) => (
                                        <div key={season} className="room-mobile-price-row">
                                            <span className="room-mobile-season-badge" style={{ color, background: bg }}>{season}</span>
                                            <div className="room-mobile-price-values">
                                                {single ? (
                                                    <span className="room-mobile-price-single">{single}원</span>
                                                ) : (
                                                    <>
                                                        <span className="room-mobile-price-item"><em>주중</em>{weekday}원</span>
                                                        {weekend && <span className="room-mobile-price-item"><em>주말</em>{weekend}원</span>}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}

                <div className="main-divider"><span></span></div>

                <div className="section-header">
                    <span className="section-label">FACILITIES</span>
                    <h2 className="section-title">객실 구비시설</h2>
                </div>
                <div className="room-facility-grid">
                    {FACILITIES.map(({ icon, name }) => (
                        <div key={name} className="room-facility-item">
                            <span className="room-facility-icon">{icon}</span>
                            <span className="room-facility-name">{name}</span>
                        </div>
                    ))}
                </div>

                <div className="main-divider"><span></span></div>

                <div className="section-header">
                    <span className="section-label">NOTICE</span>
                    <h2 className="section-title">이용 안내</h2>
                </div>
                <div className="res-caution-grid">
                    {[
                        { title: '◎ 입·퇴실 안내', items: ['입실: 오후 3시 이후', '퇴실: 오전 11시 이전', '청소 시간 확보를 위해 시간 엄수 부탁드립니다.'] },
                        { title: '◎ 객실 이용 안내', items: ['모든 객실 금연 (외부 지정 장소 이용)', '인원 초과 무단 입실 제한 (추가요금 또는 퇴실 조치)', '반려동물 동반 불가'] },
                        { title: '◎ 펜션 내 에티켓', items: ['밤 10시 이후 소음 자제 (매너타임)', '객실 내 고기·생선 굽기 및 기름 요리 금지', '집기류 파손 시 변상 비용 청구'] },
                        { title: '◎ 바베큐장 이용', items: ['이용 시간: 오후 5시 ~ 밤 10시', '사전 예약 필수 (별도 요금)', '날씨에 따라 운영 제한'] },
                        { title: '◎ 화재 및 안전', items: ['불꽃놀이·폭죽·촛불 사용 금지', '개인 화로 및 장작 사용 금지', '화기 사용 시 안전수칙 준수'] },
                        { title: '◎ 퇴실 시 협조사항', items: ['식기류 세척 후 정리', '쓰레기 분리수거 후 지정 장소 배출', '조명·냉난방기기 전원 OFF 확인'] },
                    ].map(({ title, items }) => (
                        <div key={title} className="res-caution-card">
                            <h3 className="res-caution-title">{title}</h3>
                            <ul className="res-caution-list">
                                {items.map((item, i) => <li key={i}>{item}</li>)}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="res-closing">
                    편안하고 즐거운 여행이 되실 수 있도록 언제나 최선을 다하겠습니다. 감사합니다.
                </div>
            </div>
        </div>
    );
};

export default Rooms;
